/**
 * The two attributes on `<html>` that decide how the page is laid out.
 *
 * Authority: bead scope-njw.
 *
 * Set from the locale rather than written into `index.html`, so that the day a
 * second locale lands there is no static `dir="ltr"` to find and remove. In v1
 * this always writes `lang="en" dir="ltr"` — and it writes it, which is the
 * difference between a value that is derived and a value that is assumed.
 */
import { activeLocale, directionOf } from './locale.ts'

export function applyDocumentLocale(doc: Document, locale: string = activeLocale()): void {
  doc.documentElement.lang = locale
  doc.documentElement.dir = directionOf(locale)
}
